import { useCallback } from 'react';
import type { OutreachRow } from '@discovr/types';
import { useOutreachSubParam } from '../../useOutreachSubParam';
import { hasThread } from './handoffStates';

/** A CRM row click opens the creator's conversation in the Inbox; a creator nobody has contacted has none to open. */
export function useOpenThreadRow() {
  const { openThread } = useOutreachSubParam();
  return useCallback(
    (row: Pick<OutreachRow, 'entryId' | 'outreachState'>) => {
      if (hasThread(row)) openThread(row.entryId);
    },
    [openThread],
  );
}
